import { render, staticRenderFns } from "./LoginRegister.vue?vue&type=template&id=43c76f0c&"
import script from "./LoginRegister.vue?vue&type=script&lang=ts&"
export * from "./LoginRegister.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports